<template>
  <div>
    <callMeMile v-if="isMobile" />
    <div v-else class="callme_total_wrap">
      <div class="callme_bottom_wrap">
        <div class="bottom_container">
          <div class="contact_info">
            <div class="logo_wrap">
              <img src="../../assets/home/logo.png" alt="logo" class="logo" />
              <img src="../../assets/home/logo_text.png" alt="logo_text" class="logo_text" />

            </div>
            <p class="contact_title">联系我们</p>
            <p class="contact_phone">400-608-3777</p>
            <p class="contact_email">官方邮箱：hrkj@chnsoft.com.cn</p>
            <p class="contact_address">公司地址：中国（上海）自由贸易试验区川桥路701弄3号103室</p>
            <p class="contact_wechat" 
              style="position: relative;">
              <img src="../../assets/home/weiXin.png" alt="微信" class="wechat_icon" @mouseenter="showWechatQr = true" @mouseleave="showWechatQr = false"/>
              <span @mouseenter="showWechatQr = true" @mouseleave="showWechatQr = false" style="cursor: pointer;">微信公众号</span>
              <span v-if="showWechatQr" class="wechat-qr-pop">
                <img src="../../assets/home/wxCode.jpg" alt="微信二维码" class="wechat-qr-img" />
              </span>
            </p>
          </div>


        </div>
        <div class="links_wrap">
          <div class="links_column">
            <p class="link_title">地空协同智能航空站（自动机场）</p>
            <p @click="handleProductClick('集群式换电航站', 'product_lie_1')">集群式换电航站</p>
            <p @click="handleProductClick('换电式自动机场', 'product_lie_2')">换电式自动机场</p>
            <p @click="handleProductClick('充电式自动机场', 'product_lie_3')">充电式自动机场</p>
            <p @click="handleProductClick('垂起固定翼机场', 'product_lie_4')">垂起固定翼机场</p>
            <p @click="handleProductClick('大载重自动机场', 'product_lie_5')">大载重自动机场</p>
            <p @click="handleProductClick('空地一体母站', 'product_lie_5_1')">空地一体母站</p>
            <!-- <p class="link_title mt25">移动航空站系列</p> -->
            <p @click="handleProductClick('移动航空站', 'product_lie_6')">移动航空站</p>
            <p @click="handleProductClick('无人装备指挥车', 'product_lie_7')">无人装备指挥车</p>
            <p class="link_title mt25">陆空协同无人车（机器人）</p>
            <p @click="handleProductClick('陆空协同无人消防车', 'product_lie_8')">陆空协同无人消防车</p>
            <p @click="handleProductClick('陆空协同应急处置机器人', 'product_lie_9')">陆空协同应急处置机器人</p>
            <p @click="handleProductClick('陆空协同智能巡视机器人', 'product_lie_8_1')">陆空协同智能巡视机器人</p>
            <p @click="handleProductClick('室内应急处置机器人', 'product_lie_8_2')">室内应急处置机器人</p>
          </div>
          <div class="links_column">
            <p class="link_title">海空协同无人船（艇）</p>
            <p @click="handleProductClick('海空协同无人船（艇）', 'product_lie_10')">海空协同无人船（艇）</p>

            <p class="link_title mt25">软件系统</p>
            <p @click="handleProductClick('智能全域巡视系统', 'product_lie_11')">智能全域巡视系统</p>
            <p @click="handleProductClick('全域电网巡检系统', 'product_lie_12')">全域电网巡检系统</p>
            <p class="link_title mt25">全国产化智能大、小脑（服务器）</p>
            <p @click="handleProductClick('机载智能大脑', 'product_lie_13')">机载智能大脑</p>

            <p @click="handleProductClick('车(船)载智能大(小)脑', 'product_lie_13_1')">车(船)载智能大(小)脑</p>
            <p @click="handleProductClick('边端算力服务器', 'product_lie_13_2')">边端算力服务器</p>
            <p @click="handleProductClick('云端算力服务器', 'product_lie_14')">云端算力服务器</p>
            <p class="link_title mt25">其他产品</p>
            <p @click="handleProductClick('系留供电装置', 'product_lie_15')">系留供电装置</p>
            <p @click="handleProductClick('无人装备便携地面站', 'product_lie_16')">无人装备便携地面站</p>
            <!-- <p @click="handleProductClick('机载任务系统', 'product_lie_18')">机载任务系统</p> -->
            <p @click="handleProductClick('无人装备驾控台', 'product_lie_17')">无人装备驾控台</p>
          </div>
          <div class="links_column" style="width: 180PX;">
            <p class="link_title">行业应用</p>
            <p @click="handleIndustryPowerClick('无人＋公共安全', 'industry_uav_safe')">无人＋公共安全</p>
            <p @click="handleIndustryPowerClick('无人＋执法', 'industry_safety_1')">无人＋执法</p>
            <p @click="handleIndustryPowerClick('无人＋应急', 'industry_safety_2')">无人＋应急</p>
            <p @click="handleIndustryPowerClick('无人＋环保', 'industry_other_4')">无人＋环保</p>
            <p @click="handleIndustryEnergyClick('无人＋森林', 'industry_uav_forest')">无人＋森林</p>
            <p @click="handleIndustryEnergyClick('无人＋水利', 'industry_uav_water')">无人＋水利</p>
            <p @click="handleIndustryEnergyClick('无人＋投送', 'industry_uav_delivery')">无人＋投送</p>
            <p @click="handleIndustryEnergyClick('输电线路', 'industry_power_1')">输电线路</p>
            <p @click="handleIndustryEnergyClick('变电（换流）站', 'industry_power_2')">变电（换流）站</p>
            <p @click="handleIndustrySafetyClick('配网', 'industry_power_3')">配网</p>
            <p @click="handleIndustrySafetyClick('光伏发电', 'industry_energy_1')">光伏发电</p>
            <p @click="handleIndustrySafetyClick('风力发电', 'industry_energy_2')">风力发电</p>
            <p @click="handleIndustrySafetyClick('抽水蓄能', 'industry_energy_3')">抽水蓄能</p>
            <div class="pRight">
              <p @click="handleIndustryOtherClick('石油', 'industry_energy_4')">石油</p>
              <p @click="handleIndustryOtherClick('天然气', 'industry_energy_5')">天然气</p>
              <p @click="handleIndustryOtherClick('管网', 'industry_guan_wang')">管网</p>
              <p @click="handleIndustryOtherClick('矿业', 'industry_other_3')">矿业</p>
              <p @click="handleIndustryOtherClick('公路', 'industry_gong_lu')">公路</p>
              <p @click="handleIndustryOtherClick('地铁', 'industry_tie_lu')">铁路</p>
              <p @click="handleIndustryOtherClick('地铁', 'industry_di_tie')">地铁</p>
              <p @click="handleIndustryOtherClick('边海防', 'industry_other_2')">边海防</p>
              <p @click="handleIndustryOtherClick('港口', 'industry_other_5')">港口</p>
              <p @click="handleIndustryOtherClick('基础建设', 'industry_other_6')">基础建设</p>
              <p @click="handleIndustryOtherClick('海洋', 'industry_hai_yang')">海洋</p>
            </div>
          </div>
          <div class="links_column">
            <p class="link_title">用户案例</p>

            <p @click="handleAllUserCasesClick(1)">低空经济</p>
            <p @click="handleAllUserCasesClick(2)">电网</p>
            <p @click="handleAllUserCasesClick(3)">新能源</p>
            <p @click="handleAllUserCasesClick(4)">能源</p>
            <p @click="handleAllUserCasesClick(5)">轨道交通</p>
            <p @click="handleAllUserCasesClick(6)">其他</p>
          </div>
          <div class="links_column">
            <p class="link_title">企业相关</p>
            <p @click="$router.push('/news_center')">新闻中心</p>
            <p @click="$router.push('/about_us')">公司简介</p>
            <p @click="$router.push('/about_us')">荣誉资质</p>
            <p @click="$router.push('/about_us')">加入我们</p>
            <p @click="showConsultDialog = true">客服咨询</p>
          </div>
        </div>
<div class="footer-divider"></div>
        <div class="footer">
          <p>华软科技股份有限公司版权所有 <a href="https://beian.miit.gov.cn/#/Integrated/index">沪ICP备2025148463号</a></p>
        </div>
        <ConsultDialog v-if="showConsultDialog" @close="showConsultDialog = false" :visible="showConsultDialog"
          @submit="handleConsultSubmit">
        </ConsultDialog>
        <el-dialog :visible.sync="dialogVisible" width="500px" class="consult-dialog">
          <div class="dialog-content">
            <div class="icon">
            </div>
            <p>信息已提交，请耐心等待...</p>
            <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import callMeMile from './callMeMile.vue';
import ConsultDialog from '../navbar/ConsultDialog.vue';


export default {
  name: "CallMe",
  components: { callMeMile, ConsultDialog },
  data() {
    return {
      showWechatQr: false,
      showConsultDialog: false,
      dialogVisible: false,
      isMobile: window.innerWidth <= 900
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 900;
    },
    setProductLocalStorage(text) {
      if (text) {
        localStorage.setItem('selectedText', text);
        if (text == '海空协同无人船（艇）') {
          localStorage.setItem('TeDianBgProName', '水上智能航空站');
        } else if (text == '陆空协同无人消防车') {
          localStorage.setItem('TeDianBgProName', '陆空协同无人消防车');
        } else if (text == '算力服务器') {
          localStorage.setItem('TeDianBgProName', 'ZF-C200 边缘计算终端');
        } else if (text == '机载板卡') {
          localStorage.setItem('TeDianBgProName', 'ZF-A400 算力板卡');
        } else if (text == '系留供电装置') {
          localStorage.setItem('TeDianBgProName', '系留供电装置');
        } else if (text == '无人装备便携地面站') {
          localStorage.setItem('TeDianBgProName', '无人装备便携地面站');
        } else if (text == '机载任务系统') {
          localStorage.setItem('TeDianBgProName', 'AMS-400-V112 机载任务系统');
        } else if (text == '无人装备驾控台') {
          localStorage.setItem('TeDianBgProName', '无人装备驾控台');
        } else if (text == '智能全域巡视系统') {
          localStorage.setItem('TeDianBgProName', '智能全域巡视系统');
        } else if (text == '全域电网巡检系统') {
          localStorage.setItem('TeDianBgProName', '全域电网巡检系统');
        }
        else {
          localStorage.setItem('TeDianBgProName', text);
        }
      }
    },
    handleConsultSubmit() {
      this.showConsultDialog = false
      this.dialogVisible = true
    },
    handleProductClick(text, source) {
      localStorage.setItem('selectedText', text);
      this.setProductLocalStorage(text)
      this.$router.push({ path: '/product_lie', query: { source } });
    },
    handleLinkClick(text) {
      // 跳转前将名称存入 localStorage
      localStorage.setItem('selectedText', text); this.setProductLocalStorage(text)
      this.$router.push({ path: `/page/${encodeURIComponent(text)}` });
    },
    handleIndustryPowerClick(text, source) {
      localStorage.setItem('selectedText', text); this.setProductLocalStorage(text)
      this.$router.push({ path: '/industry_application', query: { source } });
    },
    handleIndustryEnergyClick(text, source) {
      localStorage.setItem('selectedText', text); this.setProductLocalStorage(text)
      this.$router.push({ path: '/industry_application', query: { source } });
    },
    handleIndustrySafetyClick(text, source) {
      localStorage.setItem('selectedText', text); this.setProductLocalStorage(text)
      this.$router.push({ path: '/industry_application', query: { source } });
    },
    handleIndustryOtherClick(text, source) {
      localStorage.setItem('selectedText', text); this.setProductLocalStorage(text)
      this.$router.push({ path: '/industry_application', query: { source } });
    },
    handleAllUserCasesClick(type) {
      // 使用完整路径字符串并编码 query，避免某些浏览器/路由解析问题导致首次跳错到 home
      const q = `?source=all_user_cases&navUserCaseType=${encodeURIComponent(type)}`;
      this.$router.push(`/all_user_cases${q}`).catch(err => {
        // 屏蔽 NavigationDuplicated 或其他可忽略的跳转错误
        if (err && err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  padding: 0px 18.75%;
  background: #1d1f24 url('../../assets/home/callBg.png') no-repeat center center;
  background-size: cover;
  color: #fff;

  .callme_bottom_wrap {
    padding: 50PX 0;

    .footer-divider {
      width: 90%;
      height: 1px;
      background-color: #ffffff33;
      // background: linear-gradient(309deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 100%);
      margin: 23px auto 40px; /* 底部距离 footer 40px，居中显示 */
    }
    .bottom_container {
      display: flex;
      justify-content: space-between;
      width: 30%;
      float: left;

      .contact_info {
        flex: 1;

        .logo_wrap {
          display: flex;
          align-items: center;
          margin-bottom: 24PX;

          .logo {
            // width: 50px; 
            height: 50PX;
            margin-right: 12PX;


          }

          .logo_text {
            width: auto;
            height: 30PX;
            margin-right: 12PX;
            display: flex;
            align-items: center;
          }

          .company_name {
            font-size: 20PX;
            font-weight: bold;
            color: #fff;
          }
        }

        .contact_title {
          font-size: 16PX;
          margin-bottom: 12PX;
        }

        .contact_phone {
          font-size: 24PX;
          margin-bottom: 24PX;
        }

        .contact_email,
        .contact_address,
        .contact_wechat {

          font-size: 14PX;
          margin-bottom: 20PX;
          opacity: 1;
          padding-right: 30px;
        }
      }




    }

    .links_wrap {
      flex: 3;
      display: flex;
      justify-content: space-between;

      .links_column {
        position: relative;

        .link_title {
          font-size: 14PX;
          margin-bottom: 16PX;
          color: #fff;
          opacity: 1;
          font-weight: bold;
        }

        .pRight {
          position: absolute;
          left: 139PX;
          top: 38PX;
          width: 60PX;
        }


        p {
          font-size: 12PX;
          margin-bottom: 16px;
          opacity: 0.8;
          cursor: pointer; // 新增：鼠标悬浮变小手
        }
      }
    }

    .footer {
      text-align: center;
      margin-top: 30px;
      font-size: 14PX;
      color: #888;
    }
  }

  .contact_wechat {
    display: flex;
    align-items: center;
    position: relative;

    .wechat_icon {
      width: 20px;
      height: 20px;
      margin-right: 5px;
      cursor: pointer;
    }

    .wechat-qr-pop {
      position: absolute;
      left: 0px;
      top: 30px;
      background: transparent; // 由 #fff 改为 transparent，去除黑色或白色背景
      padding: 8px;
      border-radius: 6px;
      // box-shadow: 0 2px 8px rgba(0,0,0,0.15); // 保持注释，避免阴影
      z-index: 10;
      min-width: 200px;
      min-height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      opacity: 1;
    }

    .wechat-qr-img {
      width: 180px;
      height: 180px;
      // object-fit: contain;
      display: block;
    }
  }
}

// 新增媒体查询，收缩padding
@media (max-width: 1680px) {
  .callme_total_wrap {
    padding: 0px 12%;
  }
}

@media (max-width: 1440px) {
  .callme_total_wrap {
    padding: 0px 5%;
  }
}

@media (max-width: 900px) {
  .callme_total_wrap {
    padding: 0px 2%;
  }
}

.mt25 {
  margin-top: 32px;
}
.consult-dialog {
  .dialog-content {
    text-align: center;
    width: 100%;
    height: 400px;
    text-align: center;
    padding: 20px;
    background-image: url('../../assets/home/clockBg.png');
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .icon {
      font-size: 50px;
      color: #0f6bf6;
      margin-bottom: 60px;
      background-image: url('../../assets/home/clock.png'); // 确保图片路径正确
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      width: 140px;
      /* 修改宽度 */
      height: 140px;
      /* 修改高度 */
    }

    p {
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: bold;
      line-height: normal;
      letter-spacing: normal;
      color: #1E242A;
      opacity: 1;
      margin-bottom: 30px;
    }

    .el-button {
      width: 160px;
      height: 40px;
      border-radius: 4px;
      background: #0F6BF6;
      margin: 0 auto;
    }
  }
}

::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-dialog__body {
  padding: 0 !important;
}

::v-deep .el-dialog__footer {
  padding: 10px !important;
}

::v-deep .el-input__inner {
  border: none;
}
</style>